import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { Box } from '@mui/material';
import { REDIR_BLACKLIST } from '../context';
import Loading from '../Portal/Loading';

export default function AuthCallback() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isAuthenticated) {
      const lastUrl = localStorage.getItem('phx-lastUrl');
      if (lastUrl) {
        try {
          const lastLoc = JSON.parse(lastUrl);
          if (
            lastLoc.pathname &&
            lastLoc.pathname.includes('/admin') &&
            !REDIR_BLACKLIST.includes(lastLoc.pathname) &&
            !lastLoc.pathname.includes('auth-callback')
          ) {
            const navigateTo = `${lastLoc.pathname}${lastLoc.search || ''}`;
            console.log('Redirecting to:', navigateTo);
            navigate(navigateTo);
          } else {
            console.log('Redirecting to dashboard (URL in blacklist, invalid, or is auth-callback)');
            localStorage.removeItem('phx-lastUrl');
            navigate('/admin/dashboard');
          }
        } catch (e) {
          console.error('Error parsing stored URL:', e);
          localStorage.removeItem('phx-lastUrl');
          navigate('/admin/dashboard');
          return;
        }
      } else {
        console.log('No stored URL found, redirecting to dashboard');
        navigate('/admin/dashboard');
      }
    }
  }, [auth.isAuthenticated, navigate]);

  useEffect(() => {
    if (auth.error) {
      console.error('Error during authentication:', auth.error);
      navigate('/admin/dashboard');
    }
  }, [auth.error, navigate]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (auth.isLoading) {
        console.warn('Auth callback timeout, redirecting to dashboard');
        navigate('/admin/dashboard');
      }
    }, 15000);

    return () => clearTimeout(timeout);
  }, [auth.isLoading, navigate]);

  if (auth.isLoading) {
    return <Loading />;
  }

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Loading />
    </Box>
  );
}
